// src/app/pages/senate/Senate.ts

import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-senate',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './senate.html',
  styleUrl: './senate.css'
})
export class Senate implements OnInit {

  constructor(private seo: SeoService) {}

  ngOnInit(): void {

    this.seo.update(
      'Lydia Christensen for U.S. Senate',
      'Lydia Christensen is an American politician from Michigan and a Libertarian candidate for the United States Senate in 2026. Learn about her Senate campaign, background, and policy positions.',
      'senate'
    );

    this.seo.setStructuredData({
      '@context': 'https://schema.org',

      '@type': 'WebPage',

      '@id': 'https://www.lydialynnchristensen.com/senate#webpage',

      'url': 'https://www.lydialynnchristensen.com/senate',

      'name': 'Lydia Christensen for U.S. Senate',

      'description':
        'Information about Lydia Christensen and her campaign for the United States Senate in Michigan in 2026.',

      'isPartOf': {
        '@id': this.seo.websiteId
      },

      'about': {
        '@id': this.seo.lydiaId
      },

      'mainEntity': {
        '@id': this.seo.lydiaId
      },

      'publisher': {
        '@id': this.seo.campaignId
      }
    });
  }
}